import { useAuth0 } from '@auth0/auth0-react'
import React, { Fragment, useEffect, FC } from 'react'
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom'
import 'semantic-ui-css/semantic.min.css'
import { History } from 'history'

import './App.scss'
import ProtectedRoute from './auth/protected-route'
import { Layout, Loading } from './components'
import {
  ActivateTreatment,
  Auth0Callback,
  DownloadT01App,
  EmailVerification,
  Home,
  OnboardUser,
  NotFound,
  SetupCaregiverProfile,
  SetupPatientProfile,
  VerifyEmail
} from './views'

/** ********** */
type ScrollToTopProps = {
  history: History
}

const ScrollToTop: FC<ScrollToTopProps> = ({ history, children }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0)
    })
    return () => {
      unlisten()
    }
  }, [history])

  return <Fragment>{children}</Fragment>
}

const ScrollToTopOnRoute = withRouter(ScrollToTop)

/** ********** */
const App: FC = () => {
  const { isLoading } = useAuth0()

  if (isLoading) {
    return (
      <Layout>
        <Loading fullScreen />
      </Layout>
    )
  }

  return (
    <Fragment>
      <BrowserRouter>
        <ScrollToTopOnRoute>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/callback" exact component={Auth0Callback} />
            <Route path="/onboard-user" exact component={OnboardUser} />
            <ProtectedRoute
              path="/verify-email"
              exact
              component={VerifyEmail}
            />
            <Route
              path="/user-email-verification"
              exact
              component={EmailVerification}
            />
            <ProtectedRoute
              path="/setup-caregiver-profile"
              exact
              component={SetupCaregiverProfile}
            />
            <ProtectedRoute
              path="/setup-patient-profile"
              exact
              component={SetupPatientProfile}
            />
            <ProtectedRoute
              path="/activate-treatment"
              exact
              component={ActivateTreatment}
            />
            <ProtectedRoute
              path="/download-endeavorrx"
              exact
              component={DownloadT01App}
            />
            <Route path="*" exact component={NotFound} />
          </Switch>
        </ScrollToTopOnRoute>
      </BrowserRouter>
    </Fragment>
  )
}

export default App
